import Entity from "./entity";
import Member from "./member";
import Objective from "./objective";
import ReviewMember from "./review-member";
import ReviewTeam from "./review-team";

export default class Review extends Entity<string> {
  name: string;
  startDate: string;
  endDate: string;
  teamworkOption: number;
  calculationOption: number;
  gradingOption: number;
  parentRoleName: string;
  childRoleName: string;
  gradeModel: string;
  content: string;
  contentVersion: string;
  hashTags: string;
  archived: boolean;
  ownerId: number;
  owner: Member;
  description: string;
  trackingResult: number;
  selfAverageResult: number;
  otherAverageResult: number;
  averageResult: number;
  userTrackingResults: number[];
  objectives: Objective[];
  members: ReviewMember[];
  teams: ReviewTeam[];
  grantedPermissions;
}
